<h2 mat-dialog-title>
  <mat-icon class="title-icon">shopping_cart</mat-icon>
  Cart Snapshot - Order ID: {{ _data.order_id }}
</h2>
<mat-dialog-content style="max-height: 70vh; overflow-y: auto;">
  @if (_data.order_snapshot) {
  <!-- Customer Information -->
  <mat-card appearance="outlined" class="info-card">
    <mat-card-header>
      <mat-card-title>Customer Information</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="info-grid">
        <div class="info-item">
          <span class="label">Name:</span>
          <span class="value">{{ _data.name }}</span>
        </div>
        <div class="info-item">
          <span class="label">Email:</span>
          <span class="value">{{ _data.shipping_email }}</span>
        </div>
        <div class="info-item">
          <span class="label">Country:</span>
          <span class="value">{{ _data.iso2 }}</span>
        </div>
      </div>
      @if (_data.order_snapshot.shipping_address) {
      <div class="info-item full-width">
        <span class="label">Shipping Address:</span>
        <span class="value">{{
          formatAddress(_data.order_snapshot.shipping_address)
        }}</span>
      </div>
      }
    </mat-card-content>
  </mat-card>

  <!-- Cart Items -->
  <mat-card appearance="outlined" class="items-card">
    <mat-card-header>
      <mat-card-title>Cart Items</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (_data.order_snapshot.items && _data.order_snapshot.items.length > 0)
      {
      <div class="items-list">
        @for (item of _data.order_snapshot.items; track item.id) {
        <div class="item-row">
          <div class="item-image">
            @if (item.product_image) {
            <img fhImageUrl [originalUrl]="item.product_image" [alt]="item.product_name" />
            } @else {
            <div class="no-image">
              <mat-icon>image</mat-icon>
            </div>
            }
          </div>
          <div class="item-details">
            <div class="item-name">{{ item.product_name }}</div>
            <div class="item-meta">
              <span class="meta-item">Option: {{ item.addon_name }}</span>
              <span class="meta-item">Vendor: {{ item.vendor_name }}</span>
              <span class="meta-item">Quantity: {{ item.quantity }}</span>
            </div>
          </div>
          <div class="item-pricing">
            <div class="price-row">
              <span class="price-label">Unit Price:</span>
              <span class="price-value"
                >{{ _data.currency }}
                {{ item.finalPrice | number : "1.2-2" }}</span
              >
            </div>
            <div class="price-row">
              <span class="price-label">Delivery:</span>
              <span class="price-value"
                >{{ _data.currency }}
                {{ item.delivery_price | number : "1.2-2" }}</span
              >
            </div>
            <div class="price-row total">
              <span class="price-label">Subtotal:</span>
              <span class="price-value"
                >{{ _data.currency }}
                {{ item.finalPrice * item.quantity | number : "1.2-2" }}</span
              >
            </div>
          </div>
        </div>
        <mat-divider />
        }
      </div>
      } @else {
      <p class="no-items">No items in cart</p>
      }
    </mat-card-content>
  </mat-card>

  <!-- Price Summary -->
  <mat-card appearance="outlined" class="summary-card">
    <mat-card-header>
      <mat-card-title>Price Summary</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="summary-grid">
        <div class="summary-row">
          <span class="summary-label">Subtotal:</span>
          <span class="summary-value"
            >{{ _data.currency }}
            {{ _data.sub_total | number : "1.2-2" }}</span
          >
        </div>
        <div class="summary-row">
          <span class="summary-label">Shipping:</span>
          <span class="summary-value"
            >{{ _data.currency }}
            {{ _data.shipping_total | number : "1.2-2" }}</span
          >
        </div>
        @if (_data.total_discount > 0) {
        <div class="summary-row discount">
          <span class="summary-label">Total Discount:</span>
          <span class="summary-value"
            >-{{ _data.currency }}
            {{ _data.total_discount | number : "1.2-2" }}</span
          >
        </div>
        }
        <mat-divider />
        <div class="summary-row total">
          <span class="summary-label">Total:</span>
          <span class="summary-value"
            >{{ _data.currency }} {{ _data.total | number : "1.2-2" }}</span
          >
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  } @else {
  <p class="no-data">No snapshot data available</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="primary">Close</button>
</mat-dialog-actions>
